import React from 'react';
export function WhatYouGet() {
  const tomos = [{
    color: '#22C55E',
    title: 'TOMO 1 — Cimientos y Cardio-Box',
    desc: '24 sesiones · Guardia, jab, cross, hook, uppercut y primeras combinaciones'
  }, {
    color: '#EAB308',
    title: 'TOMO 2 — Técnica de Base Avanzada',
    desc: '24 sesiones · Jab táctico, ataque multinivel, defensa básica y guanteo técnico'
  }, {
    color: '#D97706',
    title: 'TOMO 3 — Ataque y Potencia Real',
    desc: '24 sesiones · Cadena cinética, las 5 combinaciones de KO y velocidad de manos'
  }, {
    color: '#EF4444',
    title: 'TOMO 4 — Defensa Avanzada',
    desc: '24 sesiones · Los 7 sistemas defensivos, contraataque automático y corner work'
  }, {
    color: '#A855F7',
    title: 'TOMO 5 — Sparring y Táctica de Combate',
    desc: '24 sesiones · Plan A + Plan B, análisis del rival y gestión de rounds'
  }, {
    color: '#FACC15',
    icon: '⭐',
    title: 'TOMO 6 — Especialización, Legado y Cierre',
    desc: 'Estilo personal · Mentoring · Combinación propia · Cierre del año y La Gran Velada'
  }];
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-475">
      <div className="max-w-3xl mx-auto" data-id="element-476">
        <div className="bg-black border border-gray-800 rounded-2xl p-6 sm:p-10" data-id="element-477">
          {/* Header */}
          <h2 className="text-2xl sm:text-3xl font-black text-[#F97316] mb-1" data-id="element-478">
            🥊 LOS 6 TOMOS
          </h2>
          <p className="text-gray-400 text-sm sm:text-base mb-8" data-id="element-479">
            Para entrenadores de boxeo de todos los niveles
          </p>

          {/* Tomo list */}
          <div className="space-y-8" data-id="element-480">
            {tomos.map((tomo, i) => <div key={i} className="flex items-start gap-4" data-id="element-481">
                {/* Color dot or icon */}
                <div className="flex-shrink-0 mt-1" data-id="element-482">
                  {tomo.icon ? <span className="text-2xl" data-id="element-483">{tomo.icon}</span> : <div className="w-6 h-6 rounded-full" style={{
                backgroundColor: tomo.color
              }} data-id="element-484" />}
                </div>
                {/* Text */}
                <div data-id="element-485">
                  <h3 className="text-white text-lg sm:text-xl font-black leading-tight mb-1" data-id="element-486">
                    {tomo.title}
                  </h3>
                  <p className="text-gray-300 text-sm sm:text-base leading-relaxed" data-id="element-487">
                    {tomo.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}